import { Box, Button, Dropdown } from '@opendoor/bricks-next';
import type { SavedSearchFieldsFragment } from '__generated__/athena';
import { MapLocationSearch } from 'components/marketplace/map/LocationSearch';
import type { LocationSearchProps } from 'components/marketplace/map/LocationSearch';
import { SAVED_SEARCHES_ENABLED } from 'components/marketplace/savedSearches/featureFlag';
import { SavedSearchesDropdown } from 'components/marketplace/savedSearches/SavedSearchesDropdown';

interface QuickFiltersProps {
  bathrooms: string;
  bedrooms: string;
  onFilterChange: (beds: string, baths: string) => void;
  isLoadingFilter: boolean;
  onFiltersButtonClick: () => void;
  onApplySavedSearch: (savedSearch: SavedSearchFieldsFragment) => void;
}

export const QuickFilters = ({
  bathrooms,
  bedrooms,
  onFilterChange,
  isLoadingFilter,
  setSelectedAddress,
  selectedAddress,
  setSelectedLocation,
  selectedLocation,
  onFiltersButtonClick,
  isFocused,
  onApplySavedSearch,
}: QuickFiltersProps & LocationSearchProps) => {
  const handleOnBedroomsChange = (value: string) => {
    onFilterChange(value, bathrooms);
  };

  const handleOnBathroomsChange = (value: string) => {
    onFilterChange(bedrooms, value);
  };

  return (
    <Box justifyContent="space-between" flexDirection="row" width="100%" my={25} gap={20}>
      <Box flex={2} width="40%">
        <MapLocationSearch
          isFocused={isFocused}
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          setSelectedLocation={setSelectedLocation}
          selectedLocation={selectedLocation}
        />
      </Box>
      <Box $smallerThanLG={{ display: 'none' }} flex={1} minWidth={88}>
        <Dropdown
          id="bedrooms"
          name="bedrooms"
          prefilledValue={bedrooms?.toString() || undefined}
          options={[
            {
              label: '1+',
              value: '1',
            },
            {
              label: '2+',
              value: '2',
            },
            {
              label: '3+',
              value: '3',
            },
            {
              label: '4+',
              value: '4',
            },
          ]}
          placeholderOption={{
            label: '0',
            value: undefined,
          }}
          size="small"
          title="Beds"
          onValueChange={handleOnBedroomsChange}
        />
      </Box>
      <Box $smallerThanLG={{ display: 'none' }} flex={1} minWidth={88}>
        <Dropdown
          id="bathrooms"
          name="bathrooms"
          prefilledValue={bathrooms?.toString() || undefined}
          options={[
            {
              label: '1+',
              value: '1',
            },
            {
              label: '2+',
              value: '2',
            },
            {
              label: '3+',
              value: '3',
            },
            {
              label: '4+',
              value: '4',
            },
          ]}
          placeholderOption={{
            label: '0',
            value: undefined,
          }}
          size="small"
          title="Baths"
          onValueChange={handleOnBathroomsChange}
        />
      </Box>
      <Button
        analyticsName="filter-property-search"
        data-testid="filter-property-search"
        label="Filters"
        onPress={onFiltersButtonClick}
        size="xsmall"
        variant="secondary"
        height="65%"
        alignSelf="flex-end"
        flex={1}
        maxWidth={82}
        minWidth="min-content"
        loading={isLoadingFilter}
      />
      {SAVED_SEARCHES_ENABLED && (
        <Box alignSelf="flex-end">
          <SavedSearchesDropdown onApplySavedSearch={onApplySavedSearch} />
        </Box>
      )}
    </Box>
  );
};
